import React from 'react';
import classNames from 'classnames';
import spinner from './spinner.gif';
import styles from './styles.module.scss';

interface SpinnerProps {
  customContainerStyles?: string
}

const Spinner = ({customContainerStyles}: SpinnerProps) => (
  <div className={classNames(customContainerStyles)}>
    <div className={styles.spinnerContainer}>
      <img
        src={spinner}
        alt="spinner"
        className={styles.spinner}
      />
    </div>
  </div>
);

export default Spinner;
